import React, {useEffect} from 'react';
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import HideAppBar from "../../../widgets/header/HideAppBar";
import {Container} from "@mui/material";
import Grid from "@mui/material/Grid";
import AllProgettiCard from "../home/AllProgettiCard";

const AllProgettiPage = () => {
	const classes = BaseStyle();
	
	useEffect(() => {
		document.body.style = `background: none;`;
	}, []);
	
	return (
		<React.Fragment>
			<main className={classes.main}>
				<HideAppBar title={"Tutti i progetti"}/>
				<Container maxWidth={"xl"} component={"article"} style={{paddingTop: 12}}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<AllProgettiCard/>
						</Grid>
					</Grid>
				</Container>
			</main>
		</React.Fragment>
	);
};

export default React.memo(AllProgettiPage);
